module.exports = __webpack_public_path__ + "static/media/S3.f399268b.png";